import React from 'react';
import animation from './search-animated.gif';
import InfographicDesktopSrc from './infographic-desktop.svg';
import InfographicMobileSrc from './infographic-mobile.svg';
import styles from './AnalyzeWebsiteTraffic.module.css';
import { useResolutionInfo } from '@mm/hooks';

export const AnalyzeWebsiteTraffic = ({ website }: { website: string }) => {
  const { screenWidth } = useResolutionInfo();
  const isMobile = screenWidth <= 700;
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <div className={styles.heading}>
          Our system is analyzing your traffic and generating your report
        </div>
        <div className={styles.website}>{website}</div>
      </div>

      <div className={styles.animationContainer}>
        <div className={styles.text}>this can take up to 1 minute...</div>
        <img src={animation} className={styles.animation} />
      </div>

      <div>
        {isMobile ? (
          <img src={InfographicMobileSrc} />
        ) : (
          <img src={InfographicDesktopSrc} />
        )}
      </div>
    </div>
  );
};
